import React from 'react';

const SubHeading = ({ title }) => (
    <div style={{ marginBottom: '1rem' }}>
        <p className="p__cormorant">{title}</p>
    </div>
);

export default SubHeading;